import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Login } from './login.model'
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  // private authStatusListener = new Subject<boolean>();
  selectedLogin: Login = {
    userName: '',
    password: '',
    changePwd: '',
    confirmPwd: '',
  };
  noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };
  constructor(private http: HttpClient) { }

  login(authCredentials){
    ////console.log(authCredentials)
    return this.http.post<any>(environment.apiBaseUrl + '/auth/signin', authCredentials,this.noAuthHeader);
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
  }

  getToken() {
    ////console.log('Getting token', localStorage.getItem('token'))
    return localStorage.getItem('token');
  }

  deleteToken() {
    localStorage.removeItem('token');
    localStorage.removeItem('firstTimeLogin')
    localStorage.removeItem('balance')
  }

  setStatus(shouldBlock: Boolean) {
    localStorage.setItem('shouldBlock', shouldBlock.toString());
  }

  shouldBlock() {
    return localStorage.getItem('shouldBlock')=='true';
  }
  
  getUserPayload() {
    var token = this.getToken();
    if (token) {
      var userPayload = atob(token.split('.')[1]);
      ////console.log('Inside getUserPayload', userPayload);
      return JSON.parse(userPayload);
    }
    else
      return null;
  }
  isLoggedIn() {
    var userPayload = this.getUserPayload();
    ////console.log('Got payload while checking login', userPayload)
    if (userPayload)
      return userPayload.exp > Date.now() / 1000;
    else
      return false;
  }

  getUserProfile() {
    return this.http.get<any>(environment.apiBaseUrl + '/user/userProfile');
  }

  changePassword(credentials){
    return this.http.post<any>(environment.apiBaseUrl+'/user/change-password', credentials);
  }

  sendOTP(userName){
    return this.http.post<any>(environment.apiBaseUrl+`/auth/sendOTP`, userName, this.noAuthHeader);
  }

  resetPassword(credentials){
    return this.http.post<any>(environment.apiBaseUrl+`/auth/reset-password`, credentials, this.noAuthHeader);
  }

  forgotUsername(credentials){
    return this.http.post<any>(environment.apiBaseUrl+`/auth/forgot-username`, credentials, this.noAuthHeader);
  }

  updateUser(updatedUser){
    return this.http.post<any>(environment.apiBaseUrl + '/user/edit-profile', updatedUser);
  }

  changePasswordFirstLogin(loginCred){
    return this.http.post<any>(environment.apiBaseUrl+`/auth/change-password-first-login`, loginCred);
  }




}
